module.exports = __webpack_public_path__ + "static/media/insegna-GEM-Casalpusterlengo-pannelli-solary-green-energy.865dc1ac.jpg";